import { render } from "./standaloneTemplate.vue?vue&type=template&id=7a08506a"
import script from "./standaloneTemplate.vue?vue&type=script&lang=js"
export * from "./standaloneTemplate.vue?vue&type=script&lang=js"

import "./standaloneTemplate.vue?vue&type=style&index=0&id=7a08506a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__